import { render, staticRenderFns } from "./FraudLayout.vue?vue&type=template&id=b599555c&"
import script from "./FraudLayout.vue?vue&type=script&lang=js&"
export * from "./FraudLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports